import React from "react";

const BannerTwo = () => {
  return (
    <div>
    <h1>
    Muitos homens iniciaram uma nova era na sua vida a partir da leitura de
    um livro.
    </h1>
    <h3>Henry David Thoreau</h3>
    </div>
  );
};

export default BannerTwo;